import { UserStore } from '~/app-modules/user/stores/user.store';
import { TBusinessAreaResponse } from '~/app-modules/business-area/clients/dto/business-area-response';
import { UserClient } from '~/app-modules/user/clients/user-client';
import { AuthService } from '~/app-modules/auth/services/auth-service';
import { AuthUserService } from '~/app-modules/user/services/auth-user-service';
import { BusinessAreaService } from '~/app-modules/business-area/services/business-area-service';
import { UserAccessRightService } from '~/app-modules/user-access-right/services/user-access-right-service';

@singleton()
export class UserService {
  constructor(
    private readonly authService: AuthService,
    private readonly authUserService: AuthUserService,
    private readonly businessAreaService: BusinessAreaService,
    private readonly userAccessRightService: UserAccessRightService,
    protected userStore: UserStore,
    protected userClient: UserClient,
  ) {
    watchEffect(async () => {
      // авторизация потеряна
      if (!authService.isLoggedIn) {
        this.userStore.currentUser = undefined;
      } else if (authService.isLoggedIn) {
        // авторизация получена
        await this.tryLoadUser();
        await this.reloadBusinessAreas();
      }
    });
  }

  get currentUser() {
    return this.userStore.currentUser;
  }

  get fullName() {
    return this.userStore.fullName;
  }

  get currentBusinessArea() {
    return this.userStore.currentBusinessArea;
  }

  set currentBusinessArea(value: TBusinessAreaResponse) {
    this.userStore.currentBusinessArea = value;
  }

  get allAvailableBusinessAreas() {
    return this.userStore.allAvailableBusinessAreas;
  }

  getAllUsers() {
    return this.userClient.getAll();
  }

  async ensureCurrentUser() {
    if (!this.userStore.currentUser) await this.tryLoadUser();

    return this.userStore.currentUser;
  }

  async tryLoadUser() {
    if (!this.authService.isLoggedIn) return;

    const [currentUser, permissions] = await Promise.all([
      this.authUserService.getCurrentUser(),
      this.userAccessRightService.getPermissionsForCurrentUser(),
    ]);

    this.userStore.currentUser = {
      firstName: currentUser.firstName,
      lastName: currentUser.lastName,
      permissions,
    };
  }

  async reloadBusinessAreas() {
    this.userStore.allAvailableBusinessAreas =
      await this.businessAreaService.getAvailableForCurrentUser();

    const needSetDefaultBusinessArea =
      !this.userStore.currentBusinessArea ||
      !this.userStore.allAvailableBusinessAreas.some(
        (ba) => ba.id === this.userStore.currentBusinessArea!.id,
      );

    if (needSetDefaultBusinessArea) {
      this.userStore.currentBusinessArea = this.userStore.allAvailableBusinessAreas[0];
    }
  }
}
